import * as React from "react";
import {
  Container,
  Dropdown,
  Nav,
  Navbar,
  NavDropdown,
  NavLink,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import defaultLogo from "../../svgs/bank-logo.svg";
import tcbLogo from "../../svgs/bank-logo-tcb.svg";
import { visibleNavGroups } from "../../config/clientResolver";
import * as Icons from "../icons/NewIcons.tsx"
import { useContext, useState } from "react";
import { AuthContext } from "../../auth/AuthRoute";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import "../../sass/_dashboard.scss";
import ChangeLandingLayout from "./ChangeLandingLayout.tsx";
import PageContext from "../sub-components/PageContext.jsx";
import SnackbarAlert from "../sub-components/SnackbarAlert.jsx";

const HeaderBanner = () => {
  // different hovering options for different menubars
  const navigate = useNavigate();

  const [homePageHover, setHomePageHover] = useState(false);
  const [rebateWorkflowHover, setRebateWorkflowHover] = useState(false);
  const [portfolioManagementHover, setPortfolioManagementHover] =
    useState(false);
  const [clientPortfolioSetupHover, setClientPortfolioSetupHover] =
    useState(false);
  const [userAdministrationHover, setUserAdministrationHover] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showChangeLayoutPopup, setShowChangeLayoutPopup] = useState(false);
  const logoMap: Record<string, string> = {
    'bank-logo.svg': defaultLogo,
    'bank-logo-tcb.svg': tcbLogo,
  };

  const bankLogoFile = process.env.REACT_APP_BANK_LOGO || 'bank-logo.svg';
  const argusIcon = logoMap[bankLogoFile] ?? defaultLogo;
  const { sessionLogout, getUserfullname, getEmail } =
    useContext(AuthContext);

  // initialize state for snackbar
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("info");
  const [showSpinner, setShowSpinner] = useState(false);
  // function to set snackbar state
  const snackbarAlert = (_show: any, message: string, color: string) => {
    setSnackbarMessage(message);
    setSnackbarColor(color);
    setShowSnackbar(true);
  };
  // object to pass variables to context
  const settings = {
    showSnackbar,
    setShowSnackbar,
    snackbarColor,
    snackbarMessage,
    snackbarAlert,
    showSpinner,
    setShowSpinner,
  };

  // set state for usename

  // adding elements on hover to the tiles
  const addHomePageNavElements = () => setHomePageHover(true);
  const addPortfolioManagementNavElements = () => {
    setPortfolioManagementHover(true);
  };
  const addRebateWorkflowNavElements = () => setRebateWorkflowHover(true);
  const addClientPortfolioNavElements = () =>
    setClientPortfolioSetupHover(true);
  const addUserAdminNavElements = () => setUserAdministrationHover(true);

  // removing elements after mouse leave to the tiles
  const removeHomePageNavElements = () => setHomePageHover(false);
  const removePortfolioManagementNavElements = () =>
    setPortfolioManagementHover(false);
  const removeRebateWorkflowNavElements = () => setRebateWorkflowHover(false);
  const removeClientPortfolioNavElements = () =>
    setClientPortfolioSetupHover(false);
  const removeUserAdminNavElements = () => setUserAdministrationHover(false);

  // dynamically adding different states to the tiles component
  const navConfigData = {
    homePage: {
      hoverState: homePageHover,
      addElements: addHomePageNavElements,
      removeElements: removeHomePageNavElements,
    },
    portfolioManagement: {
      hoverState: portfolioManagementHover,
      addElements: addPortfolioManagementNavElements,
      removeElements: removePortfolioManagementNavElements,
    },
    rebateWorkflow: {
      hoverState: rebateWorkflowHover,
      addElements: addRebateWorkflowNavElements,
      removeElements: removeRebateWorkflowNavElements,
    },
    clientPortfolioSetup: {
      hoverState: clientPortfolioSetupHover,
      addElements: addClientPortfolioNavElements,
      removeElements: removeClientPortfolioNavElements,
    },
    userAdministration: {
      hoverState: userAdministrationHover,
      addElements: addUserAdminNavElements,
      removeElements: removeUserAdminNavElements,
    },
  };
  //Outlined icons to be added in the page
  const navIcons = (status) => {
    switch (status) {
      case "credit_card":
        return <Icons.HomeDefaultRebateWorkflowIcon className="icon-style" />;
      case "leaderboard":
        return <Icons.HomeDefaultPortfolioManagementIcon className="icon-style" />;
      case "meeting_room":
        return <Icons.HomeDefaultClientProfileSetupIcon className="icon-style" />;
      case "contact_page":
        return <Icons.HomeDefaultUserAdministrationIcon className="icon-style" />;
      case "home":
        return <HomeOutlinedIcon sx={{ color: 'gray' }} className="icon-style-home" />;
      case "man":
        return <PersonOutlineOutlinedIcon className="icon-style-man" />;
      case "person":
        return <PersonOutlineOutlinedIcon className="icon-style-person" />;
      case "layout":
        return <DashboardCustomizeOutlinedIcon className="icon-style" />;
      default:
        return <PersonOutlineOutlinedIcon className="icon-style" />;
    }
  };
  //Filled icons to be added in the page
  const navFilledIcons = (status) => {
    switch (status) {
      case "credit_card":
        return <Icons.HomeHoverRebateWorkflowIcon className="icon-style" />;
      case "leaderboard":
        return <Icons.HomeHoverPortfolioManagementIcon className="icon-style" />;
      case "meeting_room":
        return <Icons.HomeHoverClientProfileSetupIcon className="icon-style" />;
      case "contact_page":
        return <Icons.HomeHoverUserAdministrationIcon className="icon-style" />;
      case "home":
        return <HomeOutlinedIcon className="icon-style-home" />;
      case "man":
        return <PersonOutlineIcon className="icon-style-man" />;
      case "person":
        return <PersonOutlineIcon className="icon-style-person" />;
      case "layout":
        return <DashboardCustomizeIcon className="icon-style" />;
      default:
        return <PersonOutlineIcon className="icon-style" />;
    }
  };
  // Gathering the title for different menubars
  const fetchTitle = (link, isFilled) => {
    let icon = "";
    let title = "";
    let homeIcon = "";
    if (!link.icon) {
      icon = link;
    } else {
      icon = link.icon;
      title = link.id === "homePage" ? "Home" : link.name;
      homeIcon = link.id === "homePage" ? "input-group-addon-home" : "";
    }
    return (
      <>
        <span
          className={`material-symbols-outlined input-group-addon ${homeIcon}`}
        >
          {isFilled ? navFilledIcons(icon) : navIcons(icon)}
        </span>
        {title}
      </>
    );
  };

  const redirectTo= (url) => {
        navigate(url);
      }

  return (
    <PageContext.Provider value={settings}>
      <header className="header-banner">
        <SnackbarAlert />
        <Navbar bg="#D9D9D9" expand="sm">
          <Container className="ms-0 me-0 container-md container-lg container-xl  container-xxl dashboard-container">
            <Navbar.Brand className="mr-1" key="argusIconKey">
              <Nav.Link className="p-0 " onClick={()=> redirectTo("/MainLanding")}>
                <img src={argusIcon} alt={process.env.REACT_APP_BANK_NAME || 'Bank'} className="logocss" />
              </Nav.Link>
            </Navbar.Brand>

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto mt-2 main-nav">
                <Nav.Link
                  id="home-page-id"
                  onMouseOver={() => setHomePageHover(true)}
                  onMouseOut={() => setHomePageHover(false)}
                  key="home"
                  /* as={Link} */
                  onClick = {() => redirectTo("/MyDashboard")}

                  as={NavLink}
                >
                  {homePageHover === true
                    ? fetchTitle("home", true)
                    : fetchTitle("home", false)}
                  <div className="home-link-span">Home</div>
                </Nav.Link>
                {visibleNavGroups
                  .filter((link) => link.id !== "homePage")
                  .map((link, index) => {
                    return (
                      <NavDropdown
                        className="m-0 p-0 mt-0 rounded nav-dropdown-div nav-bar-dropdown-div"
                        title={
                          navConfigData[link.id].hoverState === true
                            ? fetchTitle(link, true)
                            : fetchTitle(link, false)
                        }
                        onClick={navConfigData[link.id].addElements}
                        onMouseOver={navConfigData[link.id].addElements}
                        onMouseOut={navConfigData[link.id].removeElements}
                        key={link.id + index}
                        id={link.id + "-nav-item-dropdown"}
                        onBlur={navConfigData[link.id].removeElements}
                      >
                        <div className="pt-1 pb-1 nav-item-div">
                          {link.links.map((item, i) => (
                            <NavDropdown.Item
                              as={Link}
                              key={link.id + item.id + i}
                              to={item.link}
                              className="nav-link-dropdown-item"
                            >
                              {item.name}
                            </NavDropdown.Item>
                          ))}
                        </div>
                      </NavDropdown>
                    );
                  })}
              </Nav>
            </Navbar.Collapse>
            <Navbar.Collapse
              id="man-navbar-nav justify-content-end"
              key="headerKey"
            >
              <Nav className="user-profile-icon justify-content-end">
                <NavDropdown
                  className="fs-21 pt-1 pe-0 ps-0 padding-right-0 man-profile-dropdown "
                  title={fetchTitle("man", false)}
                  show={showProfilePopup}
                  onToggle={(isOpen) => setShowProfilePopup(isOpen)}
                >
                  <Dropdown.Menu
                    align={{ lg: "start" }}
                    className="square rounded-0 border-0 pt-0 dropdown-menu-options"
                  >
                    <div
                      id="example-fade-text"
                      className="user-profile rounded-3 pt-1 pb-2 position-absolute"
                    >
                      <div className="row pt-3 gx-0 man-div-row">
                        <div className="col-md-3 pe-4">
                          <span className=" p-2  ms-3 rounded-circle profile-icon">
                            {navIcons("person")}
                          </span>
                        </div>
                        <div className="col-md-9 ps-0">
                          <h4 className="primary-color mb-1 person-outline-title">
                            {getUserfullname()}
                          </h4>
                          <p
                            title="kalpana@transunion.com"
                            className="fs-12 mb-2 grey-color person-email"
                          >
                            {getEmail()}
                          </p>
                          <p className="fs-12 signout">
                            {" "}
                            <a
                              href="#"
                              onClick={() => {
                                sessionLogout();
                              }}
                            >
                              Signout
                            </a>
                          </p>
                        </div>
                      </div>
                      <div
                        className="row gx-0 gy-2 pt-1 pb-1 man-div-row"
                        onClick={() => setShowChangeLayoutPopup(true)}
                      >
                        <div className="col-md-2 ps-2 dashboard-icon">
                          <span className="material-symbols-outlined mt-1 outlined-dashboard">
                            {navIcons("layout")}
                          </span>
                          <span className="material-symbols-outlined ms-2 mt-1 filled-dashboard">
                            {navFilledIcons("layout")}
                          </span>
                        </div>
                        <div className="col-md-10 ps-0 pe-7 ">
                          <span className="ps-2 grey-color text-start change-landing-page">
                            Change My Landing Page
                          </span>
                        </div>
                      </div>
                      <ChangeLandingLayout
                        title="Landing Page Options"
                        show={showChangeLayoutPopup}
                        primaryButtonName="Update"
                        secondaryButtonName="Cancel"
                        onModalClose={() => setShowChangeLayoutPopup(false)}
                      />
                    </div>
                  </Dropdown.Menu>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </PageContext.Provider>
  );
};

export default HeaderBanner;
